import { render } from "./status.vue?vue&type=template&id=08871b04"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__